export const blankReg = /(\(.*?\))/g // NOSONAR